export default {
  SET_TOKEN(state, token) {
    state.token = token
  }
}
